// Local hint so the app can decide synchronously on boot whether to show the
// lock screen (before the /v1/me round-trip). Kept in sync with the server's
// pinSet/biometric state.
const LOCK_KEY = 'incpt_lock_v1';

export function hasLockFlag(): boolean {
  try {
    return localStorage.getItem(LOCK_KEY) === '1';
  } catch {
    return false;
  }
}

export function setLockFlag(on: boolean): void {
  try {
    if (on) localStorage.setItem(LOCK_KEY, '1');
    else localStorage.removeItem(LOCK_KEY);
  } catch {
    /* ignore */
  }
}
